import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PDFPreview from '../../ui_pdf-viewer/component';
import Portal from '../../ui_portal/component';
import { Button } from 'audamatic-ui';
import GoogleBooksPreview from '../_google-books-preview/component';
import { getDevice } from '@utils';
import Text from '@text';
import './styles/styles.scss';

/**
 * PDP preview component
 */
class ProductPreview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPreview: false,
      previewPDF: null,
      pdfEngine: null,
      fetchingPdf: false,
    };

    this.pdfBookPreview = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  get title() {
    return this.product.name || '';
  }

  get preview() {
    return this.product.preview || null;
  }

  get sku() {
    return this.product.sku || this.product.SKU;
  }

  get product() {
    return this.props.product;
  }

  handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      this.closePreview();
    }
  };

  closePreview = () => {
    this.setState({
      showPreview: false,
    }, () => this.toggleScroll(false));
  };

  toggleScroll(disable) {
    document.documentElement.style.overflowY = disable ? 'hidden' : '';
  }

  showPreviewComponentFull() {
    this.setState({
      showPreview: true,
    }, this.toggleScroll(true));
  }

  handleClick = (e) => {
    e.preventDefault();
    const { hasPdf, hasGooglePreview } = this.props;
    if (hasPdf) {
      this.showPreviewComponentFull();
    } else if (hasGooglePreview) {
      this.displayGooglePreview();
    }
    return;
  };

  displayGooglePreview() {
    const { googlePreviewUrl } = this.props;
    const { isMobile } = getDevice();
    if (isMobile) {
      return window.location.href = googlePreviewUrl;
    }

    return this.showPreviewComponentFull();
  }

  render() {
    const { pdfUrl, hasPdf, hasGooglePreview } = this.props;
    const { showPreview, fetchingPdf } = this.state;

    return (
      <div className="bookpreview-button" data-test-id="bookpreview-button">
        <Button variant="secondary" size="large" disabled={fetchingPdf} loading={fetchingPdf} onClick={this.handleClick}>
          <Text>comp.bookpreview.button-title</Text>
        </Button>

        <Portal className="book-preview-portal">
          {hasPdf && showPreview && (
            <PDFPreview url={pdfUrl} closePreview={this.closePreview}/>
          )}

          {hasGooglePreview && showPreview && (
            <GoogleBooksPreview sku={this.sku} closePreview={this.closePreview}/>
          )}

        </Portal>
      </div>
    );
  }
}

// proptypes
ProductPreview.propTypes = {
  product: PropTypes.object,
  /**
   * The title of the book
   */
  title: PropTypes.string,
  /**
   * The url to a PDF-file with a preview of the book
   */
  preview: PropTypes.string,
  pdfUrl: PropTypes.string,
  googlePreviewUrl: PropTypes.string,
  store: PropTypes.object,
  pdf: PropTypes.object,
  fetchPdf: PropTypes.func,
  hasGooglePreview: PropTypes.bool,
  hasPdf: PropTypes.bool,
};
export default ProductPreview;
